import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there is a hash, scroll to the element
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash.substring(1));
        if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 0);
    } else {
       // Otherwise scroll to top
       window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
